module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S9 Lilac Purple.73b86341.png";